import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DialogTitle, IconButton, Stack } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
export function DialogTitleWithClose({ disabled, children, onClose, }) {
    return (_jsx(DialogTitle, { children: _jsxs(Stack, Object.assign({ direction: "row", justifyContent: "space-between", alignItems: "center" }, { children: [children, _jsx(IconButton, Object.assign({ color: "inherit", onClick: onClose, disabled: !!disabled }, { children: _jsx(CloseIcon, {}) }))] })) }));
}
